<template>
  <div>
    <b-modal
      centered
      id="ModalTariffsConnectHistory"
      hide-footer
      modal-class="dialog-700"
      title="Versiones"
      @close="close()"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-table
        :items="rows"
        :fields="schema"
        :select-mode="'single'"
        responsive="sm"
        ref="selectableRatesTable1"
        selectable
        selected-variant="primary"
        @row-selected="onRowSelected"
      >
      </b-table>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ModalTariffsConnectHistory',
  props: {
    dataHistory: {
      type: Object,
      default: () => ({
        rates: [],
        selectedRate: null
      })
    },
    changeRate: {
      type: Function,
      default: () => {}
    },
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      schema: [
        { label: 'Fecha modificación', key: 'validity_date' },
        { label: 'Usuario', key: 'user_email' },
        { label: '', key: 'status' }
      ],
      rows: []
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      const rates = this.dataHistory.rates
      if (rates.length) {
        this.rows = rates.map(rate => {
          let rowVariantRate = 'none'
          if (this.dataHistory.selectedRate?.id === rate?.id) rowVariantRate = 'primary'
          let status = ''
          if (rate.type === 'current') status = 'Versión actual'
          if (rate.type === 'future') status = 'Programada'
          if (rate.type === 'expired') status = 'Versión anterior'
          return {
            ...rate,
            status,
            _rowVariant: rowVariantRate
          }
        })
      }
    },
    onRowSelected(item) {
      if (this.dataHistory?.rates !== item[0]?.id) {
        this.rows.forEach(el => el.rowVariant = 'none')
        this.$emit('changeRate', item[0])
        this.close()
      }
    },
    close() {
      this.$emit('closeModal', 'ModalTariffsConnectHistory')
    }
  }
}
</script>